import { FC } from 'react';
import { NodeTree, Resolver, useEditor } from '@craftjs/core';
import { useNodeBuffer } from './useBuffer';
import { ControlSelectorItem } from '../components/controlSelectorItem';
import { SelectorResolverType } from 'src/features/generalForms/builder/generalFormBuilder.t';
import { BufferItemType } from 'src/features/generalForms/context/formBuilderBuffer.context';

export const BufferPanel: FC<{ selectors: SelectorResolverType<Resolver> }> = ({ selectors }) => {
  const { buffer } = useNodeBuffer();
  const { query } = useEditor((state) => ({
    enabled: state.options.enabled,
    selected: state.events.selected,
  }));

  const toNodeTree = (node: BufferItemType): NodeTree => {
    const data = JSON.parse(node.nodeTree);
    const newNodes = JSON.parse(data.nodes);
    const nodePairs = Object.keys(newNodes).reduce(
      (acc, key) => ({
        ...acc,
        [key]: query.parseSerializedNode(newNodes[key]).toNode((n) => (n.id = key)),
      }),
      {},
    );

    return {
      rootNodeId: data.rootNodeId,
      nodes: nodePairs,
    };
  };

  return (
    <>
      {buffer?.map((node) => (
        <ControlSelectorItem
          Icon={selectors[node.resolvedName]?.Icon || selectors.Container.Icon}
          key={node.name}
          id={node.name}
          component={toNodeTree(node)}
          name={node.name}
        />
      ))}
    </>
  );
};
